// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
require("symbol-es6"); // fixes IE11 user dropdown bug

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import IdleVue from 'idle-vue'
import VeeValidate from 'vee-validate'
import VueGtag from "vue-gtag"
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueStripeCheckout from './shared/vue-stripe-checkout' // bug in current version of vue-stripe-checkout
import VueTheMask from 'vue-the-mask'
import VueVimeoPlayer from 'vue-vimeo-player'

import { http } from './services'

import App from './App'
import router from './router'
import config from './config.js'
import store from './store'
import components from './components'
import filters from './filters'

const eventsHub = new Vue();
const idleTimeout = 15 * 60 * 1000; // 15 minutes (in milliseconds)

Vue.use(BootstrapVue);
Vue.use(IdleVue, { eventEmitter: eventsHub, idleTime: idleTimeout, store });
Vue.use(VueLoading);
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
Vue.use(VueGtag, { config: { id: config.GTag }, appName: config.AppDomain }, router); // setup google analytics
Vue.use(VueStripeCheckout);
Vue.use(VueTheMask);
Vue.use(VueVimeoPlayer);

Vue.use(components);
Vue.use(filters);

Vue.component('Loading', VueLoading);
Vue.component('ValidationProvider', VeeValidate.ValidationProvider);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    http,
    template: '<App/>',
    components: {
        App
    }
})